import React, {
    useContext, useState, useEffect
} from 'react';
import {
    Context
} from 'shared/context/GlobalState';
import {
    Combobox
} from './ui/combobox';
import CreateSubOrganizationDialog from './AddSubOrgForm';
import {
    useNavigate, useParams
} from 'react-router-dom';

const SubOrgDropdown = ({
    urlSubOrg
}) => {
    const [subOrgs, setSubOrgs] = useState([]);
    const [selectedOrganization, setSelectedOrganization] = useState(null);
    const [show, setShow] = useState(false);

    const {
        organizations, addNewNotifcation
    } = useContext(Context);
    const {
        oragID
    } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        setSelectedOrganization(organizations?.find(item => item._id === oragID) || null);
        setSubOrgs(organizations?.find(item => item._id === oragID)?.subOrganizations || []);
    }, []);

    const onSelect = (value) => {
        localStorage.setItem('selectedSubOrg', value._id);
        navigate(`/organizations/${selectedOrganization?._id}/sub/${value._id}/ai-lab`);
    };

    return (
        <>

            {selectedOrganization?.userRole === 'superAdmin' ? (
                <Combobox
                    items={subOrgs}
                    selectedValue={urlSubOrg}
                    setter={onSelect}
                    buttonProps={{
                        text: 'Add Sub-Organization',
                        onClick: () => setShow(true),
                    }} className={undefined} />
) : (
    <Combobox
                        items={subOrgs}
                        selectedValue={urlSubOrg}
                        setter={onSelect} className={undefined} buttonProps={undefined} />
)}

            {/* {selectedOrganization?.userRole === 'superAdmin' ? (
                <Combobox
                    items={subOrgs}
                    selectedValue={urlSubOrg}
                    setter={onSelect}
                    buttonProps={{
                        text: 'Add Sub-Organization',
                        onClick: () => setShow(true),
                    }} className={undefined} />
            ) : (
                <Combobox
                    items={subOrgs}
                    selectedValue={urlSubOrg}
                    setter={onSelect} className={undefined} buttonProps={undefined}
                />
            )} */}

            <CreateSubOrganizationDialog
                show={show}
                setShow={setShow}
                addNewNotifcation={addNewNotifcation}
            />
        </>
    );
};

export default SubOrgDropdown;
